import { useEffect, useState, useCallback } from 'react';
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import { useTranslation } from "react-i18next";

function YAuth() {
    const navigate = useNavigate();
    const translation = useTranslation('mainPage');
    /** @type {any} */
    const t = translation.t;

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const handleReg = useCallback((uid, email, photoURL, providerId) => {
        const requestData = {
            uid: uid,
            email: email,
            photoURL: photoURL,
            providerId: providerId,
            referralCode: localStorage.getItem('promo'),
            period: localStorage.getItem('period'),
            tariff: localStorage.getItem('tariff'),
            ...(localStorage.getItem('userID') && { prepaidToken: localStorage.getItem('userID') }),
        };

        console.log("requestData: " + requestData);

        fetch(`https://gostlink.ru/api/register`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestData),
        })
            .then(response => {
                console.log(response);
                return response.text();
            })
            .then(text => {
                console.log(text);
                if (text) {
                    return JSON.parse(text);
                }
                return {};
            })
            .then(data => {
                console.log(data);
                if (data.success) {
                    localStorage.setItem('isYandexAuth', "true");
                    localStorage.setItem('expirationDate', data.expirationDate);
                    localStorage.setItem('subscriptionIsActive', data.subscriptionIsActive);

                    if (data.subscriptionIsActive === true){
                        navigate(`/profile`);
                    } else {
                        navigate(`/profile`);
                    }

                } else {
                    navigate(`/`);
                }
            })
            .catch(error => {
                console.error('Fetch error:', error);
                // window.close();
                navigate(`/`);
                toast.error('Не удалось авторизоваться!')
            });
    }, [navigate]);

    useEffect(() => {
        // Step 1: Extract the access_token from the URL hash.
        const hash = window.location.hash;
        const accessToken = new URLSearchParams(hash.substring(1)).get('access_token');
        localStorage.setItem('yandex_token', accessToken);

        if (accessToken) {
            // Step 2: Make the request to Yandex API to get user info.
            fetch('https://login.yandex.ru/info', {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            })
                .then((response) => response.json())
                .then(/** @param {{ client_id: string, default_email: string, default_avatar_id: string }} data */ (data) => {
                    console.log(data);
                    // Step 3: Save the user info in local storage
                    localStorage.setItem('uid', data.client_id);
                    localStorage.setItem('email', data.default_email);
                    localStorage.setItem('photoUrl', data.default_avatar_id);
                    localStorage.setItem('providerId', 'yandex.ru');
                    handleReg(data.client_id, data.default_email, data.default_avatar_id, 'yandex.ru')
                    setLoading(false);

                })
                .catch((err) => {
                    console.error('Error fetching user info:', err);
                    setError('Failed to fetch user info');
                    setLoading(false);
                });
        } else {
            setError('Access token not found in URL');
            setLoading(false);
        }
    }, [handleReg]);

    if (loading) {
        return (
            <div className="container-main">
                <h1 className="device-title" style={{textAlign: 'center', color: 'black'}}>{t('Registration.Loading')}</h1>
            </div>
        );
    }

    if (error) {
        return (
            <div className="container-main">
                <h1 className="device-title" style={{textAlign: 'center', color: 'black'}}>{error}</h1>
            </div>
        );
    }

    return (
        <div className="container-main">
            <h1 className="device-title" style={{textAlign: 'center', color: 'black'}}>{t('Registration.Login')}</h1>
        </div>
    );
}

export default YAuth;
